/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    // *** IMPORTANT: Using SAME AppSync endpoint as Customer Portal for data sync ***
    "aws_appsync_graphqlEndpoint": "https://5hdgfvi4dfbffm7w6jc4lxmq4i.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-4n647mlhincrzi3ia5qzrjgyie",
    "aws_cognito_identity_pool_id": "ap-south-1:888ad82d-f79a-48dc-a846-335f035517fc",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_VJlVz2SG2",
    "aws_user_pools_web_client_id": "47gt5pcltchc4fht0ae3vu3pof",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
